import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12 text-center" data-id="element-88">
      <div className="max-w-4xl mx-auto px-4" data-id="element-89">
        <img src="https://cdn.magicpatterns.com/uploads/26nYsWv9dqJhWEaQGDc7rp/Logo_Salon_de_Fiestas_Infantil_Colorido_Morado.png" alt="Fiesta Creativa" className="h-16 mx-auto mb-4" data-id="element-90" />
        <p className="text-gray-400 text-sm mb-8" data-id="element-91">
          Haciendo la magia de las fiestas más fácil para mamás ocupadas.
        </p>

        <div className="flex justify-center space-x-6 text-sm text-gray-400 mb-8" data-id="element-92">
          <a href="#" className="hover:text-white transition-colors" data-id="element-93">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-94">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-95">
            Contacto
          </a>
        </div>

        <p className="text-xs text-gray-500" data-id="element-96">
          &copy; {new Date().getFullYear()} Fiesta Creativa. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}